// src/pages/Login.js
import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../styles/Login.css";
import qs from "qs";
import { jwtDecode } from "jwt-decode";
import ResendRegistrationLinkBanner from "../components/ResendRegistrationLinkBanner";

const Login = ({ onLogin }) => {
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [errorCode, setErrorCode] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setErrorCode(null);
    setSubmitting(true);

    try {
      const response = await axios.post(
        "https://ghrianghraffy.com/auth/login",
        qs.stringify({ username: identifier, password }),
        { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
      );

      // If backend ever returns redirect_to (not currently), honor it
      if (response.data.redirect_to) {
        navigate(response.data.redirect_to);
        return;
      }

      const token = response.data.access_token;
      const refresh = response.data.refresh_token;
      if (!token) throw new Error("Login succeeded but no token returned.");

      localStorage.setItem("token", token);
      if (refresh) localStorage.setItem("refreshToken", refresh);

      const decoded = jwtDecode(token);
      onLogin?.(token);

      switch (decoded?.role) {
      case "ADMIN":
        navigate("/admin", { replace: true });
        break;
      case "PRINCIPAL":
        navigate("/principal-dashboard", { replace: true });
        break;
      case "STAFF":
        navigate("/staff-dashboard", { replace: true });
        break;
      case "PARENT":
      default:
        navigate("/view-photos", { replace: true });
        break;
      }
    } catch (error) {
      let msg = "Invalid username or password. Please try again.";
      let code = null;
      const data = error?.response?.data;

      if (data?.detail?.message) {
        msg = data.detail.message;
        code = data.detail.error_code || null;
      } else if (typeof data?.detail === "string") {
        msg = data.detail;
      }

      setErrorMessage(msg);
      setErrorCode(code);
      console.error("Login failed:", error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-container">
      <h1 className="login-title">Login</h1>

      <form onSubmit={handleLogin} className="login-form">
        <input
          type="email"
          className="login-input"
          placeholder="Email"
          value={identifier}
          onChange={(e) => setIdentifier(e.target.value)}
          required
        />
        <input
          type="password"
          className="login-input"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        <button type="submit" className="login-btn" disabled={submitting}>
          {submitting ? "Signing in…" : "Login"}
        </button>
      </form>
      <p style={{ marginTop: 8 }}>
        <a className="template-download-link" href="/forgot-password">Forgot your password?</a>
      </p>

      {errorMessage && <p className="error-message">{errorMessage}</p>}

      {/* If account isn’t complete yet, show resend CTA */}
      {errorCode === "INCOMPLETE_SETUP" && identifier && (
        <div style={{ marginTop: 12 }}>
          <ResendRegistrationLinkBanner email={identifier} />
        </div>
      )}
    </div>
  );
};

export default Login;
